import AuthLayout from '../../components/Layout/AuthLayout';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import ButtonWithProgress from '../../components/common/ButtonWithProgress';
import BtnEndIcon from '@material-ui/icons/KeyboardArrowRight';
import { useStyles } from '../../components/auth/Forms/_Styles';
import chatApi from '../../api/chatApi';
import { ToastNotification } from '@carbon/react';

export default function AuthPasswordResetApproved() {
  const history = useHistory()
  const classes = useStyles()
  const hasError = false
  const [pass, setPass] = useState<string>('')
  const [repeatPass, setRepeatPass] = useState('')
  const [loading, setLoading] = useState(false)
  const [isReset, setIsReset] = useState(false)
  const [stateSuccess, setStateSuccess] = useState(false)
  const [isError, setIsError] = useState(false)

  function changeIsError() {
    setIsError(!isError)
    setTimeout(() => setIsError(false), 5000)
  }

  function changeStateSuccess() {
    setStateSuccess(!stateSuccess)
    setTimeout(() => setStateSuccess(false), 5000)
  }

  const comparisonPassword = () => pass === repeatPass

  async function approvedResetHandler() {
    try {
      setLoading(true)

      if(!comparisonPassword()) {
        return changeIsError()
      }
      console.log('2222', history.location.search.split('='));
      await chatApi.resetPasswordFinish(history.location.search.split('=')[1], repeatPass)

      setIsReset(true)
      changeStateSuccess()
      setTimeout(() => history.replace('/login'), 10000)
    } catch (err) {
      changeIsError()
      console.log('при изменении пароля произошла ошибка', err);
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{height: '100%', }}>
      {
        stateSuccess &&
        <div style={{ position: 'fixed', top: 100, right: 0, zIndex: 1000 }}>
          <ToastNotification
            kind="success"
            hideCloseButton={false}
            lowContrast={false}
            iconDescription=""
            subtitle={
              <span></span>
            }
            timeout={0}
            title="Успешная регистрация, письмо с подтверждением профиля выслано вам на почту"
          />
        </div>
      }
      {
        isError &&
        <div style={{ position: 'fixed', top: 100, right: 0, zIndex: 1000 }}>
          <ToastNotification
            kind="error"
            hideCloseButton={false}
            lowContrast={false}
            iconDescription="При обновлении данных произошла ошибка"
            subtitle={
              <span>{comparisonPassword() ? 'Произошла ошибка, попробуйте позже' : 'Пароли не совпадают'}</span>
            }
            timeout={0}
            title="Ошибка"
          />
        </div>
      }
      {isReset ?
        <AuthLayout>
          <div style={{height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',}}>
            <span>Пароль успешно сброшен, Вы можете перейти на страницу авторизации самостоятельно или это будет сделано автоматически</span>
          </div>
          <div style={{margin: '0 auto'}}>
            <Button
              variant='contained'
              size={'medium'}
              color={'primary'}
              onClick={() => history.replace('/login')}>Перейти к авторизации</Button>
          </div>
        </AuthLayout> :
        <AuthLayout>
          <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', height:'100%', gap: 15 }}>
            <TextField
              error={hasError}
              label='Новый пароль'
              type='password'
              onChange={(event => setPass(event.target.value))}
              disabled={loading}
              className={classes.input}
              helperText={hasError ? 'Пароль должен быть длиннее 8 символов' : ''}
              fullWidth
            />
            <TextField
              error={hasError}
              label='Еще раз пароль'
              type='password'
              disabled={loading}
              onChange={(event) => setRepeatPass(event.target.value)}
              className={classes.input}
              helperText={hasError ? 'Пароли не совпадают' : ''}
              fullWidth
            />
          </div>
          <div className={classes.submitWrapper}>
            <ButtonWithProgress
              disabled={loading}
              loading={loading}
              variant='contained'
              color='primary'
              type='submit'
              onClick={approvedResetHandler}
              endIcon={<BtnEndIcon />}
            >
              ИЗМЕНИТЬ ПАРОЛЬ
            </ButtonWithProgress>
          </div>
        </AuthLayout>
      }
    </div>
  )
}
